<template>
  <!-- SECTION Installation Charts -->
  <div id="ChartsSection" class="row col-12 m-0 p-0">
    <div class="row col-12 m-0 mt-0 p-0 section-container justify-content-center">
      <div class="col-12 m-0 p-0 overflow-hidden justify-content-center bg-black">
        <div class="row m-0 p-0 pe-2">
          <div class="row m-0 p-0 justify-content-around">
            <div class="position-sticky col-12 m-0 p-0 pt-1 ps-4 bg-black text-white text-start">
              <div class="row p-0 m-0">

                <div class="col-4 m-0 p-0 ps-3 bg-black">
                  <select :value="currentCompany.nifCif"
                    class="form-control mt-2 mb-2 text-nowrap text-dark border bg-white"
                    style="border: solid 2px white ; max-width: 230px; color: black; display:none;"
                    @change="onCurrentCompanyChanged">
                    <option v-if="availableCompanies[0] != undefined && availableCompanies.length > 1" value="showAll">
                      {{
                        dictionary['Mostrar todo'][session.user.language] }} </option>
                    <option v-for="company in availableCompanies" :key="company.nifCif" :v-if="company.nifCif != session.user.nifCif
                      && company.relation != undefined
                      && company.relation.referenceCompany === this.session.user.nifCif" :value="company.nifCif">
                      {{ (company.nifCif === session.user.nifCif) ? "✪ " + company.name : company.name }}
                    </option>
                  </select>
                </div>

                <div class="row col justify-content-end p-0 m-0 pe-3">
                  <div class="row col justify-content-end pt-0">
                    <span class="text-end text-white mt-1 mb-2 pe-4">
                      <img src="@/assets/img/insert_chart.png" id="icon" class="material-symbols-rounded">
                      {{ dictionary["Gráficas"][session.user.language] }}
                    </span>
                  </div>
                  <div class="row col justify-content-end p-0 m-0 pt-1 pe-3" style="display: none;">
                    <button v-if="(Number(this.session.user.rol) & 164) === 164" id="btnDisplayNewDeviceModal"
                      :title="dictionary['Añadir centro de mando'][session.user.language]"
                      style="width: 30px; max-height: 30px;"
                      class="button-ok bg-transparent border-white mt-0 me-2 rounded shadow"
                      @click="toggleNewMachineModal">
                      <span>
                        <span class="button-text text-white">
                          <ion-icon name="add-circle-outline" class="pt-0 tx-18 hydrated" data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            :title="dictionary['Añadir centro de mando'][session.user.language]"></ion-icon>
                          <!--<span class="text-dark mt-0">{{ dictionary["Añadir "+((this.$route.params.currentDisplay==="emplacements")?'emplazamiento':'centro de mando')][session.user.language]}}</span>-->
                        </span>
                      </span>
                    </button>

                    <button v-if="false" id="btnDisplayEditEraseModal"
                      :title="dictionary['Editar centro de mando'][session.user.language]"
                      style="width: 30px; max-height: 30px; display: none;"
                      class="button-ok bg-transparent border-white mt-0 me-2 rounded shadow" @click="ToMachines">
                      <span>
                        <span class="button-text text-white">
                          <ion-icon name="create-outline" class="pt-0 me-0 tx-18 hydrated"
                            :title="dictionary['Editar centro de mando'][session.user.language]"></ion-icon>
                          <!--<span class="text-dark mt-0">{{ dictionary["Añadir "+((this.$route.params.currentDisplay==="emplacements")?'emplazamiento':'centro de mando')][session.user.language]}}</span>-->
                        </span>
                      </span>
                    </button>
                    <button id="btnDisplayEditEraseModal" :title="dictionary['Actualizar'][session.user.language]"
                      style="width: 30px; max-height: 30px; display:none;"
                      class="button-ok bg-transparent border-white mt-0 me-2 rounded shadow" @click="refreshView">
                      <span>
                        <span class="button-text text-white">
                          <ion-icon name="refresh-outline" class="pt-0 me-0 tx-16 hydrated"
                            :title="dictionary['Actualizar'][session.user.language]"></ion-icon>
                          <!--<span class="text-dark mt-0">{{ dictionary["Añadir "+((this.$route.params.currentDisplay==="emplacements")?'emplazamiento':'centro de mando')][session.user.language]}}</span>-->
                        </span>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <!-- HEADER Installation Charts -->
            <div class="col-md-2 col-12 m-0 ms-3 mt-3 p-3 pt-1 bg-black" style="min-width: 250px;">
              <div class="m-auto p-auto p-0 tx-white">
                <!--<div class="col-12 overflow-hidden justify-content-center">
                  <h6 class="tx-left tx-clomos-white text-center mt-0 mb-3 pt-1">
                    <ion-icon name="stats-chart" class="tx-18 me-2 align-bottom"></ion-icon>
                    {{ dictionary["Series"][session.user.language] }}
                  </h6>
                </div>-->


                <div class="p-3 pt-0 rounded-5 bg-lat1 border-1">
                  <div v-if="this.moduleAvailable === 2">
                    <label class="col-12 m-0 p-0 pb-1 pt-3 tx-12">
                      {{ dictionary['ID del dispositivo'][session.user.language] }}:
                    </label>
                    <div>
                      <!-- Campo de entrada para búsqueda -->
                      <input type="text" v-model="searchDeviceQuery" placeholder="Buscar dispositivo"
                        class="form-control mt-0 mb-2 text-dark bg-white" />

                      <!-- Select con opciones filtradas -->
                      <select v-model="targetDeviceId" @change="getDeviceData" id="selectTargetDevice"
                        class="form-control mt-0 mb-3 h-100 text-nowrap text-dark border bg-white"
                        style="padding-bottom: 3px;">
                        <option v-for="device in filteredDevices" :key="device.id" :value="device.id"
                          :selected="device.id === targetDeviceId">
                          {{ device.label }}
                        </option>
                      </select>
                    </div>

                    <label class="col-12 m-0 p-0 pb-1 tx-12">
                      {{ dictionary['Variable'][session.user.language] }}:
                    </label>
                    <select v-model="targetVariableId" id="selectTargetDevice" data-live-search="true"
                      class="form-control mt-0 mb-3 h-100 text-nowrap text-dark border bg-white"
                      style="padding-bottom: 3px;">
                      <option v-for="variable in historyVariables" :key="variable['variableId']"
                        :value="variable['variableId']" :selected="variable['variableId'] === targetVariableId">
                        {{ variable['label'][0].toUpperCase() + variable['label'].substring(1, variable['label'].length)
                        }}
                      </option>
                    </select>
                  </div>
                  <div v-if="this.moduleAvailable === 1">
                    <hr class="m-0 p-0 h-100 d-inline">
                    <label class="col-12 m-0 p-0 pb-1 tx-12">
                      {{ dictionary['Activo'][session.user.language] }}:
                    </label>

                    <div>
                      <!-- Campo de entrada para búsqueda -->
                      <input type="text" v-model="searchMachineQuery" placeholder="Buscar activo"
                        class="form-control mt-0 mb-2 text-dark" />

                      <!-- Select con opciones filtradas -->
                      <select v-model="targetDeviceId" @change="getMachineData" id="selectTargetDevice"
                        class="form-control mt-0 mb-3 h-100 text-nowrap text-dark border bg-white"
                        style="padding-bottom: 3px;">
                        <option v-for="machine in filteredMachines" :key="machine.id" :value="machine.id"
                          :selected="machine.id === targetDeviceId">
                          {{ machine.label }}
                        </option>
                      </select>
                    </div>

                    <label class="col-12 m-0 p-0 pb-1 tx-12">
                      {{ dictionary['Variable'][session.user.language] }}:
                    </label>
                    <select v-model="targetVariableId" id="selectTargetDevice" data-live-search="true"
                      :disabled="!selectVariablesEnabled"
                      class="form-control mt-3 mb-3 h-100 text-nowrap text-dark border bg-white"
                      style="padding-bottom: 3px;">
                      <option v-for="variable in historyVariables" :key="variable['variableId']"
                        :value="variable['variableId']" :selected="variable['variableId'] === targetVariableId">
                        {{ variable['label'][0].toUpperCase() + variable['label'].substring(1, variable['label'].length)
                        }}
                      </option>
                    </select>
                  </div>

                  <div class="col-12 m-0 mt-3 mb-1 p-0 pe-2 ps-2 d-flex justify-content-between"
                    style="text-align: left; vertical-align: center;">
                    <label class="m-0 p-0 tx-12">
                      {{ 'Downsampling' }}:
                    </label>
                    <input v-model="downsampling" id="checkboxTargetAxisLeft" type="checkbox"
                      style="width: 0.25rem; min-width:30px;" class="m-0 p-0 h-100 d-inline">
                  </div>

                  <div class="col-12 m-0 mt-3 mb-1 p-0 pe-2 ps-2 d-flex justify-content-between"
                    style="text-align: left; vertical-align: center;">
                    <label class="m-0 p-0 tx-12">
                      {{ dictionary['Eje izquierdo'][session.user.language] }}:
                    </label>
                    <input v-model="checkboxTargetAxisLeft" @change="checkboxTargetAxisRight = !checkboxTargetAxisLeft"
                      id="checkboxTargetAxisLeft" type="checkbox" style="width: 0.25rem; min-width:30px;"
                      class="m-0 p-0 h-100 d-inline">
                  </div>

                  <div class="col-12 m-0 mt-1 mb-1 p-0 pe-2 ps-2 d-flex justify-content-between"
                    style="text-align: left; vertical-align: center;">
                    <label class="m-0 p-0 tx-12">
                      {{ dictionary['Eje derecho'][session.user.language] }}:
                    </label>
                    <input v-model="checkboxTargetAxisRight" @change="checkboxTargetAxisLeft = !checkboxTargetAxisRight"
                      id="checkboxTargetAxisRight" type="checkbox" style="width: 0.25rem; min-width:30px;"
                      class="m-0 p-0 h-100 d-inline">
                  </div>

                  <div class="col-12 m-0 mt-1 mb-1 p-0 pe-2 ps-2 d-flex justify-content-between"
                    style="text-align: left; vertical-align: center;">
                    <label class="m-0 p-0 tx-12">
                      {{ dictionary['Escalonado'][session.user.language] }}:
                    </label>
                    <input v-model="checkboxStep" @click="checkboxStep = !checkboxStep" id="checkboxStep"
                      type="checkbox" style="width: 0.25rem; min-width:30px;" class="m-0 p-0 h-100 d-inline">
                  </div>
                  <div class="col-12 m-0 mt-3 mb-1 p-0 pe-2 ps-2 d-flex justify-content-between"
                    style="text-align: left; vertical-align: center;">
                    <label class="m-0 p-0 tx-12">
                      {{ dictionary['Lineas'][session.user.language] }}
                    </label>
                    <input v-model="lineChart" @change="barChart = !lineChart" id="checkboxTargetAxisLeft"
                      type="checkbox" style="width: 0.25rem; min-width:30px;" class="m-0 p-0 h-100 d-inline">
                  </div>

                  <div class="col-12 m-0 mt-1 mb-1 p-0 pe-2 ps-2 d-flex justify-content-between"
                    style="text-align: left; vertical-align: center;">
                    <label class="m-0 p-0 tx-12">
                      {{ dictionary['Barras'][session.user.language] }}
                    </label>
                    <input v-model="barChart" @change="lineChart = !barChart" id="checkboxTargetAxisRight"
                      type="checkbox" style="width: 0.25rem; min-width:30px;" class="m-0 p-0 h-100 d-inline">
                  </div>
                  <hr class="m-0 p-0 h-100 d-inline">

                  <div class="col-12 m-0 p-0">
                    <button type="button"
                      @click="this.moduleAvailable === 2 ? getDeviceVariableHistory(1) : getMachineVariableHistory(1)"
                      class="col-12 button-ok bg-lat1 mt-3 rounded-5 w-100 tx-12" id="btnGuardarPerfil">
                      {{ dictionary['Añadir en gráfica'][session.user.language] }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row col m-0 p-0 justify-content-end bg-black" style="min-width: 400px;">
              <!-- CARD Chart 1 -->
              <div id="cardChart1" class="p-2"
                :class="(chartSize['1'].max) ? 'col-xl-12 col-lg-12 col-md-12 col-12' : 'col-12'"
                style="min-height: 98%;">
                <div class="p-0 rounded-5 shadow">
                  <div class="row col-12 bg-black rounded-top-5 p-0 m-0 text-white">
                    <!--<div class="col-md-1 col-2 d-flex justify-content-start align-items-center p-1 ps-3" style="display: none;">
                      <span class="border-2 rounded-circle ps-2 pe-2">1</span>
                    </div>-->
                    <div
                      class="col-md-10 col-10 m-0 mb-1 mt-1 p-1 ps-3 text-white justify-content-start d-flex flex-nowrap">
                      <!--<ion-icon name="calendar-outline"></ion-icon>-->
                      <label for="incidenceSelect"
                        class="form-label text-start tx-14 pt-2 m-0 mb-2 text-nowrap fw-normal">
                        {{ dictionary['Fecha inicio'][session.user.language] }}
                      </label>
                      <input v-model="startDateTimeInput[1]" id="inputStartDate"
                        class="dateInput form-control tx-10 rounded text-nowrap me-2 p-1 border-1"
                        :type="(session.browser === 'firefox') ? 'date' : 'datetime-local'"
                        style=" max-width: 120px; max-height:34px;">
                      <label for="incidenceSelect" class="form-label text-start tx-14 pt-2 m-0 ps-3 mb-2 fw-light">
                        {{ dictionary['Fecha fin'][session.user.language] }}</label>
                      <input v-model="endDateTimeInput[1]" id="inputEndDate"
                        class="dateInput form-control tx-10 rounded text-nowrap me-1 border-1"
                        :type="(session.browser === 'firefox') ? 'date' : 'datetime-local'"
                        style="max-width: 120px; max-height:34px;">

                      <!--<ion-icon name="search-circle-outline" class="text-dark p-0 m-0 pt-1 me-2 tx-18 hydrated md"></ion-icon>-->
                      <!-- <span class="text-dark m-0 p-0 text-nowrap">{{ dictionary["Aplicar"][session.user.language]
                            }}</span> -->
                      <span class="d-flex justify-content-center align-items-center">
                        <ion-icon @click="applyChartUpdate(1)" class="c-pointer text-white tx-24 rounded"
                          name="refresh-outline"></ion-icon>
                      </span>

                    </div>

                    <div class="col-md-2 col-2 d-flex justify-content-end align-items-center p-1 pe-2">
                      <ion-icon name="download-outline" class="tx-18 p-1 btn btnSizeChart" @click="generateCSV(1, $event)">
                      </ion-icon>
                      <ion-icon name="trash-outline" class="tx-18 p-1 btn btnSizeChart"
                        @click=" chartHistory['1'] = {}">
                      </ion-icon>
                    </div>
                  </div>

                  <div class="rounded-5 pt-0 pb-1 m-0 p-2 border-1 bg-white">
                    <VueEcharts ref="chartRef" :option="chartOptions" id="Chart1Canvas" class="col-12 w-100 ps-0 pe-0"
                      style="height: 85vh;">
                    </VueEcharts>
                    <div class="d-flex flex-row justify-content-center zoom-controls m-0 p-0 pb-1">
                      <button class="d-flex m-0 ms-0 me-auto p-0 ps-1 rounded-5 justify-content-center align-content-center" style="border:solid 1px gray; color: gray; background: white; width: 2.25rem;" @click="panLeft">
                        <ion-icon name="arrow-back-circle-outline" class="text-dark m-auto ms-0 me-1 tx-20"></ion-icon>
                      </button>
                      <button class="d-flex m-0 ms-1 me-1 p-1 rounded-5 justify-content-center align-content-center" style="border:solid 1px gray; color: gray; background: white; width: 10rem;" @click="zoomIn">
                        <span class="m-auto tx-16 m-auto">Zoom</span>
                        <ion-icon name="add-circle-outline" class="text-dark m-auto ms-0 me-1 tx-20"></ion-icon>
                      </button>
                      <button class="d-flex m-0 ms-1 me-1 p-1 rounded-5 justify-content-center align-content-center" style="border:solid 1px gray; color: gray; background: white; width: 10rem;" @click="zoomReset">
                        <span class="m-auto tx-16 m-auto">Zoom Reset</span>
                      </button>
                      <button class="d-flex m-0 ms-1 me-1 p-1 rounded-5 justify-content-center align-content-center" style="border:solid 1px gray; color: gray; background: white; width: 10rem;" @click="zoomOut">
                        <span class="m-auto tx-16 m-auto">Zoom</span>
                        <ion-icon name="remove-circle-outline" class="text-dark m-auto ms-0 me-1 tx-20"></ion-icon>
                      </button>
                      <button class="d-flex m-0 ms-auto me-0 p-0 ps-1 rounded-5 justify-content-center align-content-center" style="border:solid 1px gray; color: gray; background: white; width: 2.25rem;" @click="panRight">
                        <ion-icon name="arrow-forward-circle-outline" class="text-dark m-auto ms-0 me-1 tx-20"></ion-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import $ from 'jquery';
import { VueEcharts } from 'vue3-echarts';
import echartsOptionsJson from '@/assets/json/echarts_options.json';
// Clomos
import api from '@/services/api';

export default {
  name: "ChartsComponent",
  components: { VueEcharts },
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    timeZones: {
      type: Object,
      required: true,
    },
    currentCompany: {
      type: Object,
      required: true,
    },
    availableCompanies: {
      type: Object,
      required: true,
    },
    visibility: {
      type: Object,
      required: true,
    }
  },
  watch: {
    currentCompany: async function () {
      this.machineList = [];
      this.machineData = {};
      this.deviceData = {};
      this.moduleAvailable = this.getModulesFromUrl()
      if (this.moduleAvailable === 2) {
        await this.getDeviceListByCompany();
        if (this.availableDevices[0] != undefined) {
          this.targetDeviceId = this.availableDevices[0].id;
          await this.getDeviceData();
        }
        else {
          this.targetDeviceId = ""
        }
      } else if (this.moduleAvailable === 1) {
        await this.getMachineListByCompany()
        if (this.machineList[0] != undefined) {
          this.targetDeviceId = this.machineList[0].id;
          await this.getMachineData();
        }
        else {
          this.targetDeviceId = ""
        }
      }
      if (Object.entries(this.historyVariables)[0] != undefined) {
        this.targetVariableId = Object.entries(this.historyVariables)[0][0];
      }
      else {
        this.targetVariableId = ""
      }
    },
    '$route.params.currentModule': {
      handler: async function () {
        this.machineData = {};
        this.deviceData = {};
        await this.analyzeUrl();
      },
      immediate: true
    },
    async filteredMachines(newFilteredMachines) {
      if (newFilteredMachines.length > 0) {
        this.targetDeviceId = newFilteredMachines[0].id;
        await this.getMachineData()
      } else {
        this.targetDeviceId = null;
      }
    },
    async filteredDevices(newFilteredDevices) {
      if (newFilteredDevices.length > 0) {
        this.targetDeviceId = newFilteredDevices[0].id;
        await this.getDeviceData()
      } else {
        this.targetDeviceId = null;
      }
    }
  },
  data() {
    return {
      // LAST DAY CHART
      lineChartOptions: JSON.parse(JSON.stringify(echartsOptionsJson))["lineChartOptions"],
      deviceData: {
        id: "",
        nifCif: "",
        dataConsumed: "",
        label: "",
        dclId: "",
        dclTypeId: "",
        dclClass: "",
        type: "",
        distributionGroup: "",
        parent: "",
        isBase: "",
        isPublic: 0,
        token: "",
        imgSrc: "",
        emplacement: "",
        fechaUltimaComunicacion: "",
        tieneAlarmaActivada: "",
        version: "",
        geoJSON: {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [0, 0]
          }
        },
        variables: {
          analog: {},
          digital: {},
          dynamic: {}
        }
      },
      machineData: {
        id: "",
        nifCif: "",
        dataConsumed: "",
        label: "",
        dclId: "",
        dclTypeId: "",
        dclClass: "",
        type: "",
        distributionGroup: "",
        parent: "",
        isBase: "",
        isPublic: 0,
        token: "",
        imgSrc: "",
        emplacement: "",
        fechaUltimaComunicacion: "",
        tieneAlarmaActivada: "",
        version: "",
        geoJSON: {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [0, 0]
          }
        },
        variables: {
          analog: {},
          digital: {},
          dynamic: {}
        }
      },
      availableDevices: [],
      machineList: [],
      searchDeviceQuery: "",
      searchMachineQuery: "",
      targetDeviceId: "",
      targetVariableId: "",
      checkboxTargetAxisLeft: true,
      checkboxTargetAxisRight: false,
      checkboxStep: false,
      downsampling: true,
      startDateTimeInput: {
        "1": api.parseDateTimeToString(new Date().setDate(new Date().getDate() - 1)),
      },
      endDateTimeInput: {
        "1": api.parseDateTimeToString(new Date()),
      },
      startDateTime: {
        "1": ""
      },
      endDateTime: {
        "1": ""
      },
      startDateTimeChart: {
        "1": ""
      },
      endDateTimeChart: {
        "1": ""
      },
      chartHistory: {
        "1": {}
      },
      chartSize: {
        "1": { max: true }
      },
      // COLORS
      colors: ["#c12e34",
        "#e6b600",
        "#0098d9",
        "#2b821d",
        "#005eaa",
        "#339ca8",
        "#9c28b1",
        "#32a487",
        "#e64a19"],
      selectVariablesEnabled: true,
      lineChart: true,
      barChart: false,
      umbrales: {}
    }
  },
  computed: {
    filteredDevices() {
      if (!Array.isArray(this.availableDevices) || this.availableDevices.length === 0) {
        return [];
      }
      const filtered = this.availableDevices.filter(device => {
        const label = device.label;
        return typeof label === 'string' && label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            this.searchDeviceQuery
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
      });
      filtered.sort((a, b) => {
        const labelA = a.label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const labelB = b.label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0;
      });
      return filtered;
    },
    filteredMachines() {
      if (!Array.isArray(this.machineList) || this.machineList.length === 0) {
        return [];
      }
      const filtered = this.machineList.filter(machine => {
        const label = machine.label;
        return typeof label === 'string' && label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            this.searchMachineQuery
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
      });
      filtered.sort((a, b) => {
        const labelA = a.label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const labelB = b.label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0;
      });
      return filtered;
    },
    fractionalLength() {
      return (localStorage.getItem("ClomosFractionalLength") != undefined) ? localStorage.getItem("ClomosFractionalLength") : 2;
    },
    historyVariables() {
      let historyVariables = {};
      if (this.moduleAvailable === 2) {
        for (let variableType in this.deviceData.variables)
          for (let variable in this.deviceData.variables[variableType])
            if (this.deviceData.variables[variableType][variable].saveHistory === 'true' && (variableType === 'analog' || variableType === 'digital')) {
              historyVariables[this.deviceData.variables[variableType][variable].variableId] = this.deviceData.variables[variableType][variable];
            }
      } else if (this.moduleAvailable === 1) {
        for (let variableType in this.machineData.variables)
          for (let variable in this.machineData.variables[variableType])
            if (this.machineData.variables[variableType][variable].saveHistory === 'true' && (variableType === 'analog' || variableType === 'digital')) {
              historyVariables[this.machineData.variables[variableType][variable].variableId] = this.machineData.variables[variableType][variable];
            }
      }
      return historyVariables;
    },
    chartOptions() {
      let format = this.session.user.dateTimeFormat;
      let language = this.session.user.language;
      let chartOptions = JSON.parse(JSON.stringify(this.lineChartOptions));
      if (this.targetDeviceId == "") return chartOptions;
      chartOptions.dataZoom = [
        {
          type: 'inside',
          zoomOnMouseWheel: true,
          labelFormatter: function (value) {
            let d = new Date(value);
            switch (format) {
              case "DD/MM/YYYY":
                return String(d.getDate()).padStart(2, "0") + "/" +
                  String(d.getMonth() + 1).padStart(2, "0") + "/" +
                  d.getFullYear() + " \n " +
                  String(d.getHours()).padStart(2, "0") + ":" +
                  String(d.getMinutes()).padStart(2, "0");
              case "MM/DD/YYYY":
              default:
                return String(d.getMonth() + 1).padStart(2, "0") + "/" +
                  String(d.getDate()).padStart(2, "0") + "/" +
                  d.getFullYear() + " \n " +
                  String(d.getHours()).padStart(2, "0") + ":" +
                  String(d.getMinutes()).padStart(2, "0");
            }
          }
        }
      ]
      chartOptions.legend.itemHeight = 20;
      chartOptions.legend.padding = 3;
      chartOptions.legend.textStyle = { fontSize: 9 };
      chartOptions.axisPointer = {
        label: {
          formatter: (dataTarget) => {
            let d = new Date(dataTarget.value);
            switch (format) {
              case "DD/MM/YYYY":
                return String(d.getDate()).padStart(2, "0") + "/" +
                  String(d.getMonth() + 1).padStart(2, "0") + "/" +
                  d.getFullYear() + " \n " +
                  String(d.getHours()).padStart(2, "0") + ":" +
                  String(d.getMinutes()).padStart(2, "0");
              case "MM/DD/YYYY":
              default:
                return String(d.getMonth() + 1).padStart(2, "0") + "/" +
                  String(d.getDate()).padStart(2, "0") + "/" +
                  d.getFullYear() + " \n " +
                  String(d.getHours()).padStart(2, "0") + ":" +
                  String(d.getMinutes()).padStart(2, "0");
            }
          }
        },
        fontSize: 9
      };
      chartOptions.xAxis = {
        min: new Date(this.startDateTimeInput["1"]).getTime(),
        max: new Date(this.endDateTimeInput["1"]).getTime(),
        axisLabel: {
          formatter: (value) => {
            let d = new Date(value);
            switch (format) {
              case "DD/MM/YYYY":
                return String(d.getDate()).padStart(2, "0") + "/" +
                  String(d.getMonth() + 1).padStart(2, "0") + "/" +
                  d.getFullYear() + " \n " +
                  String(d.getHours()).padStart(2, "0") + ":" +
                  String(d.getMinutes()).padStart(2, "0");
              case "MM/DD/YYYY":
                return String(d.getMonth() + 1).padStart(2, "0") + "/" +
                  String(d.getDate()).padStart(2, "0") + "/" +
                  d.getFullYear() + " \n " +
                  String(d.getHours()).padStart(2, "0") + ":" +
                  String(d.getMinutes()).padStart(2, "0");
              default:
                return String(d.getMonth() + 1).padStart(2, "0") + "/" +
                  String(d.getDate()).padStart(2, "0") + "/" +
                  d.getFullYear() + " \n " +
                  String(d.getHours()).padStart(2, "0") + ":" +
                  String(d.getMinutes()).padStart(2, "0");
            }
          },
          fontSize: 9
        }
      };
      chartOptions.toolbox = {
        feature: {
          dataView: {
              readOnly: true
          },
          saveAsImage: {
              pixelRatio: 2
          }
        }
      };
      chartOptions.tooltip = {
        trigger: "axis",
        axisPointer: {
          snap: true,
          lineStyle: { color: "#000", width: 2 }
        },
        formatter: (params) => {
          let result = (params[0] && params[0].axisValueLabel ? params[0].axisValueLabel : "") + "<br/>";
          params.forEach((item) => {
            let formattedValue = new Intl.NumberFormat(
              language === "en" ? 'en-IN' : 'es-ES',
              { maximumFractionDigits: this.fractionalLength }
            ).format(Number(item.data[1]));
            result += `${item.marker} <strong>${item.seriesName}:</strong> ${formattedValue} ${(item.data[5] ?? '')} <br/>`;
          });
          return result;
        }
      };
      const allowedSeriesTypes = new Set(["line", "bar", "scatter", "candlestick", "pie", "map", "effectScatter", "heatmap"]); // extend if needed
      const history = this.chartHistory && this.chartHistory["1"] ? this.chartHistory["1"] : null;
      if (!history) {
        console.warn("CHART-DEBUG: no chartHistory[\"1\"] found; returning base options");
        chartOptions.yAxis = chartOptions.yAxis || [{ type: "value", axisLabel: { fontSize: 9 } }];
        chartOptions.series = chartOptions.series || [];
        return chartOptions;
      }
      const axisMap = Object.create(null);
      const yAxisList = [];
      const seriesList = [];
      const legendList = [];
      let axisCounter = 0;
      let i = 0;
      for (const variable in history) {
        try {
          const entries = history[variable];
          if (!Array.isArray(entries) || entries.length === 0) {
            console.warn(`CHART-DEBUG: SKIP_EMPTY variable='${variable}'`, entries);
            continue;
          }
          const sample = entries[0];
          if (!sample || !Array.isArray(sample)) {
            console.warn(`CHART-DEBUG: INVALID_SAMPLE variable='${variable}' sample=`, sample);
            continue;
          }
          //const axisKey = variable.toUpperCase().substring(0, 3).toUpperCase() || "generic";
          let unit = sample[5] !== undefined ? sample[5].trim() : "";
          let negativeLogic = sample[6] !== undefined ? sample[6].trim() : undefined;
          let axisKey = "uni";
          if (unit != undefined) {
            unit = String(unit);
            axisKey = unit.toUpperCase();
          }
          if (negativeLogic != undefined) {
            unit = "";
            axisKey = "0/1";
          }
          let min, max;
          if (variable.includes('Presure')) {
            for (let u in this.umbrales) {
              if (min === undefined || min < Number(u[0])) min = Number(u[0]); 
              if (max === undefined || max < Number(u[3])) max = Number(u[3]); 
            }
            min = Number(this.umbrales[variable.replace("Presure-","")][0]) || 0;
            max = Number(this.umbrales[variable.replace("Presure-","")][3]) || 250;
          }
          if (!(axisKey in axisMap)) {
            axisMap[axisKey] = axisCounter;
            yAxisList.push({
              type: "value",
              //axisLine: { lineStyle: { color: this.colors[axisCounter] || '#333' } },
              axisLine: { lineStyle: { color: '#000', opacity: 0.3 } },
              name: axisKey,
              max: max,
              min: min,
              nameTextStyle: { fontSize: 9 },
              axisLabel: {
                fontSize: 9,
                formatter: (value) => {
                  try {
                    return new Intl.NumberFormat(
                      language === "en" ? "en-IN" : "es-ES",
                      { maximumFractionDigits: Number(this.fractionalLength) }
                    ).format(value) + (unit ? ` ${unit}` : "");
                  } catch (e) {
                    return String(value) + (unit ? ` ${unit}` : "");
                  }
                }
              },
              position: axisCounter % 2 === 0 ? "left" : "right",
              offset: Math.floor(axisCounter / 2) * 35
            });
            axisCounter++;
          }
          const yIndex = axisMap[axisKey];
          let rawType = sample[4];
          if (typeof rawType !== "string" || !allowedSeriesTypes.has(rawType)) {
            rawType = "line";
          }
          if (!Array.isArray(entries)) {
            console.warn(`CHART-DEBUG: INVALID_ENTRIES variable='${variable}' entries=`, entries);
            continue;
          }
          const color = this.colors[i % this.colors.length];
          //const color = this.colors[yIndex];
          const safeSeries = {
            data: entries,
            name: variable,
            yAxisIndex: yIndex,
            type: rawType,
            color: color || '#000',
            symbol: "none",
            symbolSize: 6,
            showSymbol: false,
            smooth: false,
            step: (sample[3] !== undefined ? sample[3] : false),
            areaStyle: { color: color || '#000', opacity: 0.03 }
          };
          if (safeSeries == null || typeof safeSeries !== "object") {
            console.warn(`CHART-DEBUG: INVALID_SERIES object for variable='${variable}'`, safeSeries);
            continue;
          }
          if (safeSeries.type === undefined || safeSeries.type === null) {
            console.warn(`CHART-DEBUG: SERIES_TYPE_MISSING variable='${variable}' type=`, sample[4]);
            safeSeries.type = "line";
          }
          if (variable.includes('Presure')) {
            safeSeries.markLine = {
              silent: true,
              symbol: 'none',
              lineStyle: {
                type: 'dashed',
                color: color,
                width: 2
              },
              label: {
                show: true
              },
              data: [
                {
                  yAxis: this.umbrales[variable.replace("Presure-","")][1],
                  label: {
                    formatter: 'Umb. inferior'
                  }
                },
                {
                  yAxis: this.umbrales[variable.replace("Presure-","")][2],
                  label: {
                    formatter: 'Umb. superior'
                  }
                }
              ]
            };
          }
          seriesList.push(safeSeries);
          legendList.push(variable);
        } catch (err) {
          console.error(`CHART-DEBUG: ERROR_PROCESSING variable='${variable}'`, err);
          continue;
        }
        i++;
      }
      if (yAxisList.length === 0) {
        yAxisList.push({ type: "value", name: "", axisLabel: { fontSize: 9 } });
      }
      chartOptions.yAxis = yAxisList;
      chartOptions.series = seriesList;
      chartOptions.legend.data = legendList;
      if (!Array.isArray(chartOptions.series) || chartOptions.series.length === 0) {
        console.warn("CHART-DEBUG: FINAL_SERIES_EMPTY - chartOptions.series is empty after validation. Check chartHistory structure.");
      } else {
        for (let idx = 0; idx < chartOptions.series.length; idx++) {
          const s = chartOptions.series[idx];
          if (!s || typeof s !== "object") {
            console.warn(`CHART-DEBUG: SERIES_INVALID_AT_INDEX idx=${idx}`, s);
          } else if (!s.type || typeof s.type !== "string") {
            console.warn(`CHART-DEBUG: SERIES_TYPE_INVALID idx=${idx} type=`, s.type);
          }
        }
      }
      return chartOptions;
    }
  },
  emits: ["setCurrentCompany"],
  methods: {
    generateCSV(chartNumber, triggerEvent) {
      const data = this.chartHistory[chartNumber];
      let csvContent = '"activo";"variable";"valor";"fecha"\n';
      const formatearFecha = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
      };
      Object.keys(data).forEach((key) => {
        const entries = data[key];
        const entity = key.split('-')[1];
        Object.keys(entries).forEach((sensorName) => {
          const readings = entries[sensorName];
          const date = formatearFecha(new Date(readings[0]));
          csvContent += `"${entity}"${this.session.user.fieldSeparator}"${key}"${this.session.user.fieldSeparator}"${readings[1]}"${this.session.user.fieldSeparator}"${date}"\n`;
        });
      });
      const csvName = `${this.currentCompany.name}_data.csv`;
      this.downloadCSV(csvContent, csvName, triggerEvent);
    },
    async downloadCSV(csvContent, fileName, triggerEvent) {
      const pickerWindow = triggerEvent?.view || window;
      const fileData = "\uFEFF" + csvContent;

      try {
        if ('showSaveFilePicker' in pickerWindow && pickerWindow.isSecureContext) {
          const fileHandle = await pickerWindow.showSaveFilePicker({
            suggestedName: fileName,
            types: [{
              description: 'Archivo CSV',
              accept: { 'text/csv': ['.csv'] }
            }]
          });

          const writable = await fileHandle.createWritable({ keepExistingData: false });
          const encodedData = new TextEncoder().encode(fileData);
          await writable.write({
            type: "write",
            position: 0,
            data: encodedData
          });
          await writable.close();

          const savedFile = await fileHandle.getFile();
          if (savedFile.size === 0 && encodedData.length > 0) {
            throw new Error("Empty file after write");
          }
          return;
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error al guardar el CSV de la grafica:', error);
        } else {
          return;
        }
      }

      this.fallbackDownloadCSV(csvContent, fileName);
    },
    fallbackDownloadCSV(csvContent, fileName) {
      const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    getChartInstance() {
      return this.$refs.chartRef?.getInstance();
    },
    zoomIn() {
      let chart = this.getChartInstance();
      if (!chart) return;
      let option = chart.getOption();
      let dz = option.dataZoom?.[0];
      if (!dz) return;
      let range = dz.end - dz.start;
      let delta = range * 0.2;
      chart.dispatchAction({
        type: 'dataZoom',
        start: dz.start + delta,
        end: dz.end - delta
      });
    },
    zoomOut() {
      let chart = this.getChartInstance();
      if (!chart) return;
      let option = chart.getOption();
      let dz = option.dataZoom?.[0];
      if (!dz) return;
      let range = dz.end - dz.start;
      let delta = range * 0.2;
      let start = dz.start - delta;
      let end = dz.end + delta;
      start = Math.max(0, start);
      end = Math.min(100, end);
      chart.dispatchAction({
        type: 'dataZoom',
        start,
        end
      });
    },
    zoomReset() {
      let chart = this.getChartInstance();
      if (!chart) return;
      chart.dispatchAction({
        type: 'dataZoom',
        start: 0,
        end: 100
      });
    },
    panLeft() {
      let chart = this.getChartInstance();
      if (!chart) return;
      let option = chart.getOption();
      let dz = option.dataZoom?.[0];
      if (!dz) return;
      let range = dz.end - dz.start;
      let shift = range * 0.2;
      let start = dz.start - shift;
      let end = dz.end - shift;
      if (start < 0) {
        end -= start;
        start = 0;
      }
      chart.dispatchAction({
        type: 'dataZoom',
        start,
        end
      });
    },
    panRight() {
      let chart = this.getChartInstance();
      if (!chart) return;
      let option = chart.getOption();
      let dz = option.dataZoom?.[0];
      if (!dz) return;
      let range = dz.end - dz.start;
      let shift = range * 0.2;
      let start = dz.start + shift;
      let end = dz.end + shift;
      if (end > 100) {
        start -= (end - 100);
        end = 100;
      }
      chart.dispatchAction({
        type: 'dataZoom',
        start,
        end
      });
    },
    // DISPLAY
    onCurrentCompanyChanged(event) {
      let value = event.target.value;
      this.$router.replace({ params: { currentCompanyNifCif: value } })
      this.$emit('setCurrentCompany', value);
    },
    // GET
    async getDeviceData(callback) {
      this.selectVariablesEnabled = false
      let targetVariableLabel;
      if (this.targetVariableId) {
        for (let variable of Object.values(this.historyVariables)) {
          if (variable.variableId === this.targetVariableId) {
            targetVariableLabel = variable.label;
            break;
          }
        }
      }
      let response = await api.getDeviceData(this.targetDeviceId);
      this.deviceData = api.parseDeviceFromResponse(response);
      if (Object.keys(this.historyVariables).length > 0) {
        let found = false;
        for (let variable of Object.values(this.historyVariables)) {
          if (variable.label === targetVariableLabel) {
            this.targetVariableId = variable.variableId;
            found = true;
            break;
          }
        }
        if (!found) {
          this.targetVariableId = Object.values(this.historyVariables)[0].variableId;
        }
      } else {
        this.targetVariableId = "";
      }
      this.selectVariablesEnabled = true
      if (this.deviceData.variables?.analog?.["Presure"] != undefined) {
        this.umbrales[this.deviceData.label] = [
          0,
          this.deviceData.variables?.analog?.["Umbral inferior"]?.value || 0,
          this.deviceData.variables?.analog?.["Umbral superior"]?.value || 10,
          this.deviceData.variables?.analog?.["Fondo de escala"]?.value || 10,
        ]
      }
      if (callback && typeof callback === "function") callback(this.deviceData);
    },
    async getDeviceListByCompany(callback) {
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getDeviceListByCompany(request);
      this.availableDevices = api.parseDevicesFromResponse(response);
      if (callback && typeof callback === "function") callback(this.availableDevices);
    },
    async getDeviceVariableHistory(n, requestData, callback) {
      let targetAxis = requestData ? requestData.targetAxis : (this.checkboxTargetAxisRight) ? 'right' : 'left';
      let step = requestData ? requestData.step : (this.checkboxStep) ? true : false;
      let chartType = requestData ? requestData.chartType : this.lineChart ? "line" : "bar"
      if (this.startDateTimeInput[n] === "" || this.endDateTimeInput[n] === "") {
        if (this.startDateTimeInput[n] === "")
          $("#inputStartDate").get()[0].classList.add("missing")
        if (this.endDateTimeInput === "")
          $("#inputEndDate").get()[0].classList.add("missing")
        setTimeout(() => {
          $("#inputStartDate").get()[0].classList.remove("missing")
          $("#inputEndDate").get()[0].classList.remove("missing")
        }, 3000);
        return;
      }
      if (this.deviceData != {}) {
        let request = {
          id: this.deviceData.id,
          variableLabel: this.historyVariables[this.targetVariableId].label,
          variableType: this.historyVariables[this.targetVariableId].type,
          limit: 0,
          offset: 0,
          startDateTime: api.parseDateTimeToUTCString(this.startDateTimeInput[n], this.session.user, this.$dayjs),
          endDateTime: api.parseDateTimeToUTCString(this.endDateTimeInput[n], this.session.user, this.$dayjs)
        }
        let response = await api.getDeviceVariableHistory(requestData ? requestData : request, this.downsampling);
        // PARSE HISTORY RESPONSE
        let parsedResponse = api.parseVariableDataFromHistoryResponse(response);
        let rawHistory = parsedResponse.history
        let deviceName
        if (requestData) {
          this.chartHistory[n][requestData.variableLabel + "-" + requestData.entity] = [];
          for (let i in rawHistory) {
            this.chartHistory[n][requestData.variableLabel + "-" + requestData.entity][i] = [
              // DATE
              this.$dayjs(new Date(rawHistory[i][0])).utc("z").local().tz(this.session.user.dateTimeZone).$d,
              // VALUE
              new Number(rawHistory[i][1]).toFixed(this.fractionalLength),
              // POSITION
              targetAxis,
              // STEP
              step,
              chartType,
              parsedResponse.unit,
              parsedResponse.negativeLogic
            ]
          }
        } else {
          deviceName = this.targetDeviceId === this.deviceData.id ? this.deviceData.label : null
          this.chartHistory[n][this.historyVariables[this.targetVariableId].label + "-" + deviceName] = [];
          for (let i in rawHistory) {
            this.chartHistory[n][this.historyVariables[this.targetVariableId].label + "-" + deviceName][i] = [
              // DATE
              this.$dayjs(new Date(rawHistory[i][0])).utc("z").local().tz(this.session.user.dateTimeZone).$d,
              // VALUE
              new Number(rawHistory[i][1]).toFixed(this.fractionalLength),
              // POSITION
              targetAxis,
              // STEP
              step,
              chartType,
              parsedResponse.unit,
              parsedResponse.negativeLogic
            ]
          }
        }
        // SET DATA BOUNDRIES
        this.startDateTime[n] = this.startDateTimeInput[n];
        this.endDateTime[n] = this.endDateTimeInput[n];
        if (this.startDateTimeChart[n].length > 0) {
          const startDateTime = new Date(this.startDateTime[n]);
          const startDateTimeChart = new Date(this.startDateTimeChart[n]);
          if (startDateTime.getTime() < startDateTimeChart.getTime()) {
            this.startDateTimeChart[n] = this.startDateTime[n];
          }
        } else {
          this.startDateTimeChart[n] = this.startDateTime[n];
        }
        if (this.endDateTimeChart[n].length > 0) {
          const endDateTime = new Date(this.endDateTime[n]);
          const endDateTimeChart = new Date(this.endDateTimeChart[n]);
          if (endDateTime.getTime() > endDateTimeChart.getTime()) {
            this.endDateTimeChart[n] = this.endDateTime[n];
          }
        } else {
          this.endDateTimeChart[n] = this.endDateTime[n];
        }
        this.checkboxTargetAxisRight = !this.checkboxTargetAxisRight;
        this.checkboxTargetAxisLeft = !this.checkboxTargetAxisRight;
        if (callback && typeof callback === "function") callback(this.availableDevices)
      }
    },
    async getMachineListByCompany() {
      this.machineList = [];
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getMachineListByCompany(request);
      for (let i in response.maquinas) [
        this.machineList[i] = {
          id: response.maquinas[i].idDcl,
          label: response.maquinas[i].etiqueta,
        }
      ]
    },
    async applyChartUpdate(chartNumber) {
      const data = this.chartHistory[chartNumber];
      Object.keys(data).forEach(async (key) => {
        const [variable, ...zonaParts] = key.split('-');
        const entity = zonaParts.join('-');
        const machine = this.machineList.find(machine => machine.label === entity);
        const device = this.availableDevices.find(device => device.label === entity);
        const id = machine ? machine.id : (device ? device.id : null);
        if (id) {
          const firstEntry = (!data[key] || data[key].length === 0) ? "" : data[key][0];
          const position = (!data[key] || data[key].length === 0) ? 'left' : firstEntry[2];
          const step = (!data[key] || data[key].length === 0) ? 'false' : firstEntry[3]
          const chartType = (!data[key] || data[key].length === 0) ? 'line' : firstEntry[4]
          const request = {
            id: id,
            entity: entity,
            variableLabel: variable,
            variableType: this.historyVariables[this.targetVariableId].type,
            limit: 0,
            offset: 0,
            targetAxis: position,
            step: step,
            chartType: chartType,
            startDateTime: api.parseDateTimeToUTCString(
              this.startDateTimeInput[chartNumber],
              this.session.user,
              this.$dayjs
            ),
            endDateTime: api.parseDateTimeToUTCString(
              this.endDateTimeInput[chartNumber],
              this.session.user,
              this.$dayjs
            )
          };
          setTimeout(machine ? await this.getMachineVariableHistory(chartNumber, request) : await this.getDeviceVariableHistory(chartNumber, request), 200);
        } else {
          console.warn(`No se encontró un dispositivo o máquina con el label ${entity}`);
        }
      });
    },
    async getMachineData(callback) {
      let targetVariableLabel;
      if (this.targetVariableId) {
        for (let variable of Object.values(this.historyVariables)) {
          if (variable.variableId === this.targetVariableId) {
            targetVariableLabel = variable.label;
            break;
          }
        }
      }
      let response = await api.getMachineData(this.targetDeviceId);
      this.machineData = api.parseMachineFromResponse(response);
      if (Object.keys(this.historyVariables).length > 0) {
        let found = false;
        for (let variable of Object.values(this.historyVariables)) {
          if (variable.label === targetVariableLabel) {
            this.targetVariableId = variable.variableId;
            found = true;
            break;
          }
        }
        if (!found) {
          this.targetVariableId = Object.values(this.historyVariables)[0].variableId;
        }
      } else {
        this.targetVariableId = "";
      }
      if (callback && typeof callback === "function") callback(this.targetMachineData);
    },
    async getMachineVariableHistory(n, requestData, callback) {
      let targetAxis = requestData ? requestData.targetAxis : (this.checkboxTargetAxisRight) ? 'right' : 'left';
      let step = requestData ? requestData.step : (this.checkboxStep) ? true : false;
      let chartType = requestData ? requestData.chartType : this.lineChart ? "line" : "bar"
      if (this.startDateTimeInput[n] === "" || this.endDateTimeInput[n] === "") {
        if (this.startDateTimeInput[n] === "")
          $("#inputStartDate").get()[0].classList.add("missing")
        if (this.endDateTimeInput === "")
          $("#inputEndDate").get()[0].classList.add("missing")
        setTimeout(() => {
          $("#inputStartDate").get()[0].classList.remove("missing")
          $("#inputEndDate").get()[0].classList.remove("missing")
        }, 3000);
        return;
      }
      if (this.machineData != {}) {
        let request = {
          id: this.machineData.id,
          variableLabel: this.historyVariables[this.targetVariableId].label,
          variableType: this.historyVariables[this.targetVariableId].type,
          limit: 0,
          offset: 0,
          startDateTime: api.parseDateTimeToUTCString(this.startDateTimeInput[n], this.session.user, this.$dayjs),
          endDateTime: api.parseDateTimeToUTCString(this.endDateTimeInput[n], this.session.user, this.$dayjs)
        }
        let response = await api.getMachineVariableHistory(requestData ? requestData : request, this.downsampling);
        // PARSE HISTORY RESPONSE
        let parsedResponse = api.parseVariableDataFromHistoryResponse(response);
        let rawHistory = parsedResponse.history
        let machineName
        if (requestData) {
          this.chartHistory[n][requestData.variableLabel + "-" + requestData.entity] = [];
          for (let i in rawHistory) {
            this.chartHistory[n][requestData.variableLabel + "-" + requestData.entity][i] = [
              // DATE
              this.$dayjs(new Date(rawHistory[i][0])).utc("z").local().tz(this.session.user.dateTimeZone).$d,
              // VALUE
              new Number(rawHistory[i][1]).toFixed(this.fractionalLength),
              // POSITION
              targetAxis,
              // STEP
              step,
              chartType,
              parsedResponse.unit
            ]
          }
        } else {
          machineName = this.targetDeviceId === this.machineData.id ? this.machineData.label : null
          this.chartHistory[n][this.historyVariables[this.targetVariableId].label + "-" + machineName] = [];
          for (let i in rawHistory) {
            this.chartHistory[n][this.historyVariables[this.targetVariableId].label + "-" + machineName][i] = [
              // DATE
              this.$dayjs(new Date(rawHistory[i][0])).utc("z").local().tz(this.session.user.dateTimeZone).$d,
              // VALUE
              new Number(rawHistory[i][1]).toFixed(this.fractionalLength),
              // POSITION
              targetAxis,
              // STEP
              step,
              chartType,
              parsedResponse.unit
            ]
          }
        }
        // SET DATA BOUNDRIES
        this.startDateTime[n] = this.startDateTimeInput[n];
        this.endDateTime[n] = this.endDateTimeInput[n];
        if (this.startDateTimeChart[n].length > 0) {
          const startDateTime = new Date(this.startDateTime[n]);
          const startDateTimeChart = new Date(this.startDateTimeChart[n]);
          if (startDateTime.getTime() < startDateTimeChart.getTime()) {
            this.startDateTimeChart[n] = this.startDateTime[n];
          }
        } else {
          this.startDateTimeChart[n] = this.startDateTime[n];
        }
        if (this.endDateTimeChart[n].length > 0) {
          const endDateTime = new Date(this.endDateTime[n]);
          const endDateTimeChart = new Date(this.endDateTimeChart[n]);
          if (endDateTime.getTime() > endDateTimeChart.getTime()) {
            this.endDateTimeChart[n] = this.endDateTime[n];
          }
        } else {
          this.endDateTimeChart[n] = this.endDateTime[n];
        }
        // SWITCH AXIS TARGET
        this.checkboxTargetAxisRight = !this.checkboxTargetAxisRight;
        this.checkboxTargetAxisLeft = !this.checkboxTargetAxisRight;
        if (callback && typeof callback === "function") callback(this.machineList)
      }
    },
    getModulesFromUrl() {
      try {
        switch (true) {
          case this.$route.params.currentModule.includes("smartLockers"):
            return 1;
          case this.$route.params.currentModule.includes("devices"):
            return 2;
          case this.$route.params.currentModule.includes("fabric"):
            return 1;
          case this.$route.params.currentModule.includes("electricalMonitoring"):
            return 2;
          default:
            return null;
        }
      } catch (error) {
        console.error("Error parsing URL:", error);
        return null;
      }
    },
    async analyzeUrl() {
      this.availableDevices = [];
      this.machineList = [];
      let moduleInUrl = this.getModulesFromUrl()
      if (this.moduleAvailable != moduleInUrl) this.moduleAvailable = moduleInUrl
      if (this.moduleAvailable === 2) {
        await this.getDeviceListByCompany();
        if (this.availableDevices[0] != undefined) {
          this.targetDeviceId = this.availableDevices[0].id;
          await this.getDeviceData();
        }
        else {
          this.targetDeviceId = ""
        }
      } else if (this.moduleAvailable === 1) {
        await this.getMachineListByCompany()
        if (this.machineList[0] != undefined) {
          this.targetDeviceId = this.machineList[0].id;
          await this.getMachineData();
        }
        else {
          this.targetDeviceId = ""
        }
      }
      if (Object.entries(this.historyVariables)[0] != undefined) {
        this.targetVariableId = Object.entries(this.historyVariables)[0][0];
      }
      else {
        this.targetVariableId = ""
      }
    },
    onPointerDown(e) {
      console.log("1")
      this.startY = e.clientY;
      this.lastY = e.clientY;
      this.isLongPress = false;
      this.pressTimer = setTimeout(() => {
        this.isLongPress = true;
      }, 3000);
    },
    onPointerUp() {
      console.log("4")
      clearTimeout(this.pressTimer);
      this.isLongPress = false;
    },
    onPointerMove(e) {
      console.log("2")
      if (!this.isLongPress) return;
      console.log("3")
      const deltaY = e.clientY - this.lastY;
      const threshold = 8; // avoid micro movements
      if (Math.abs(deltaY) < threshold) return;
      if (deltaY < 0) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
      this.lastY = e.clientY;
    }
  },
  mounted() {
    this.$nextTick(() => {
      const chart = this.getChartInstance();
      const zr = chart.getZr();
      zr.on('mousedown', (e) => {
        this.onPointerDown(e);
      });
      zr.on('mousemove', (e) => {
        this.onPointerMove(e);
      });
      zr.on('mouseup', (e) => {
        this.onPointerUp(e);
      });
    });
  },
  async created() {
    await this.analyzeUrl()
  }
}
</script>

<style>
#Chart1Canvas {
  touch-action: none;
}
#cardRelaysChartsContainer {
  display: flex;
  gap: 1rem;
}

#cardDigitalInputsContainer {
  display: flex;
  gap: 1rem;
}

.btnSizeChart:hover {
  color: var(--main-dark) !important;
}

.dateInput {
  color-scheme: dark;
}

.dateInput:active {
  color-scheme: light;
}

@media (max-width: 992px) {

  #cardOverall,
  #cardCurrentCharts,
  #cardSCC {
    padding-right: 1rem !important;
  }

  #cardRelaysChartsContainer,
  #cardDigitalInputsContainer {
    display: block;
  }
}
</style>
